import Config from "@/mixins/map/Config";
import Home from "@/mixins/map/Home";
import Popup from "@/mixins/map/Popup";
import Swal from "sweetalert2";
import {
  api
} from '../../store/api';

export default {
  name: 'map',
  mixins: [Config, Home, Popup],
  data() {
    return {
      activeLot: null,
      showDetail: false,
      lotmarkers: [],

      apartmentGeoJson: {
        type: 'FeatureCollection',
        features: [],
      },
      baseLayers: [],
      container: 'community-map',
      detailLayers: [],
      filteredlotGeoJson: {
        type: 'FeatureCollection',
        features: [],
      },
      layers: [],
      lotSummaryList: null,
      packageSummaryList: [],
      lotgeo: require('@/assets/json/lotgeo.json'),
      lotGeoJson: null,
      lotPanelMarker: null,
      masterBound: null,
      modelHomes: null,
      padding: {
        top: 10,
        bottom: 10,
        left: 15,
        right: 315
      },
      sources: [],
      svgConfig: null,
      arcApprovalProcessData: {},
      activeSalesProcess: {},
      stageGeoJson: {
        type: 'FeatureCollection',
        features: [],
      },
      viewBasedFilterLot: {
        type: 'FeatureCollection',
        features: [],
      }
    }
  },
  methods: {
    initMap: function (config, lotsummary, modelHomes) {
      if (window.innerWidth < 600) {
        this.padding = 5;
      }
      mapboxgl.accessToken = 'pk.eyJ1Ijoic2FpbGVzaGtjIiwiYSI6ImNrZGo1Y2l5dTBibGIzMXBmbzM5Z2Q3Z2MifQ.hq_fP_fYTmUm_LJNRl23Cw';
      if (
        config && lotsummary
      ) {
        this.lotSummaryList = lotsummary;
        this.modelHomes = modelHomes;
        this.svgConfig = config;
        this.initConfig();
      }
    },

    addLotShapes: function () {
      const bounds = new mapboxgl.LngLatBounds();
      this.lotGeoJson.features.forEach((feature) => {
        const lotname = feature.properties.lotName;
        const lotcpid = feature.properties.lotCpId;
        const lot = this.lotSummaryList.find(
          (item) => item.productname === lotname || item.lotcpid === lotcpid
        );
        if (lot) {
          feature.properties.lotproperties = lot;
          feature.id = lot.lotcpid;
          feature.properties.color = this.assignColor(lot.currentstatusname);
          feature.properties.interact = false;
          feature.properties.hoverable = null;
          feature.properties.status = lot.currentstatusname;
          feature.properties.subtype = lot.lotsubtype;
          feature.properties.isActive = false;

          if (
            lot.currentstatusname === 'available' ||
            lot.currentstatusname === 'Available' ||
            lot.currentstatusname === 'Model'
          ) {
            feature.properties.status = 'available';
            feature.properties.hoverable = 'allow';
            feature.properties.interact = true;
          }
          feature.geometry.coordinates[0].forEach((cord) => {
            bounds.extend(new mapboxgl.LngLat(cord[0], cord[1]));
          });
          this.filteredlotGeoJson.features.push(feature);
        }
      });

      this.map.addSource('lots', {
        type: 'geojson',
        data: this.filteredlotGeoJson,
      });


      this.map.addLayer({
        id: 'lot-fills',
        type: 'fill',
        source: 'lots',
        layout: {},
        paint: {
          // 'fill-color': {
          //   type: 'identity',
          //   property: 'color',
          // },
          'fill-color': [
            'case',
            ['boolean', ['get', 'isActive'], false],
            '#fff',
            ['get', 'color'],
            // '#333'
          ],
          'fill-outline-color': '#333333',
          'fill-opacity': [
            'case',
            ['boolean', ['feature-state', 'hover'], false],
            0.4,
            0.9,
          ],
        },
      });

      this.map.on('mousemove', 'lot-fills', (e) => {
        if (e.features.length > 0) {
          if (e.features[0].properties.color === '#8b586a' || e.features[0].properties.color === '#688e9f' || e.features[0].properties.color === '#c3958e' || e.features[0].properties.color === '#f0cd89') {
            this.map.getCanvas().style.cursor = 'pointer';
            if (this.hoveredLotId) {
              this.map.setFeatureState({
                source: 'lots',
                id: this.hoveredLotId
              }, {
                hover: false
              });
            }
            this.hoveredLotId = e.features[0].id;
            this.map.setFeatureState({
              source: 'lots',
              id: this.hoveredLotId
            }, {
              hover: true
            });
          }

        }
      });

      this.map.on('mouseleave', 'lot-fills', () => {
        this.map.getCanvas().style.cursor = '';
        if (this.hoveredLotId) {
          this.map.setFeatureState({
            source: 'lots',
            id: this.hoveredLotId
          }, {
            hover: false
          });
        }
        this.hoveredLotId = null;
      });

      this.map.on('click', (e) => {
        if (this.lotPanelMarker) {
          this.lotPanelMarker.remove()
        }
      })

      this.map.on('click', 'lot-fills', (e) => {
        if (e.features.length > 0) {
          const lot = JSON.parse(e.features[0].properties.lotproperties);
          if (e.features[0].properties.interact && lot.currentstatusname !== 'Model') {
            const bounds = new mapboxgl.LngLatBounds();
            e.features[0].geometry.coordinates[0].forEach((cord) => {
              bounds.extend(new mapboxgl.LngLat(cord[0], cord[1]));
            });
            const payload = {
              point: bounds.getCenter(),
              features: JSON.parse(JSON.stringify(e.features[0]))
            }
            this.$store.dispatch('productTracking', {
              page: 'lot-click',
              product: JSON.parse(payload.features.properties.lotproperties)
            })
            this.createLotMarker(payload);
          } else {
            if (lot.currentstatusname === "Spec" || lot.currentstatusname === "Sold" || lot.currentstatusname === 'Model' || lot.currentstatusname === "Closed" || lot.currentstatusname === 'Contingent Spec') {
              if (lot !== null && lot !== undefined) {
                const hnl = this.findSpecOrModelHome(this.packageSummaryList, lot.productname)
                if (hnl) {
                  const lotfeature = this.lotGeoJson.features.find(feature => feature.properties.lotCpId === hnl.lotproductcpid);
                  if (lotfeature) {
                    const markerBound = new mapboxgl.LngLatBounds();
                    lotfeature.geometry.coordinates[0].forEach((cord) => {
                      markerBound.extend(new mapboxgl.LngLat(cord[0], cord[1]));
                    });
                    this.createPackageDetailMarker(hnl, lotfeature.geometry.coordinates[0])
                  } else if (!lotfeature) {
                    this.packageNotFound();
                  }
                } else if (!hnl) {
                  this.packageNotFound();
                }
              }
            } else {
              return;
            }
          }
        }
      });

      this.placeDetailLayer();
      this.addApartmentShapes();
      if (bounds) {
        this.map.fitBounds(bounds, {
          padding: this.padding,
          maxZoom: 18
        });
      } else {
        this.map.fitBounds(this.masterBound);
      }
    },

    packageNotFound: function () {
      Swal.fire({
        icon: 'error',
        title: 'Error 404',
        text: `Sorry, we're having trouble locating this package.`
      })
    },

    findSpecOrModelHome(handlSummaries, lotProductName) {
      handlSummaries = handlSummaries.filter(handlSummary => handlSummary.lotproductname === lotProductName && ["Model", "Spec", "Contingent Spec", "Sold", "Closed"].includes(handlSummary.currentstatusname));
      if (handlSummaries && handlSummaries.length > 0) {
        if (handlSummaries.length > 1) {
          handlSummaries.sort((a, b) => compareNumbers(a.createddate, b.createddate, -1));
        }
        return handlSummaries[0];
      }
      return null;
    },

    processActiveSalesProcess: function (processes) {
      const activeProcesses = processes.filter(process => process.active === true);
      if ((activeProcesses === undefined) || activeProcesses.length === 0) {
        console.log('No active sales processes found');
        return;
      }
      if (activeProcesses.length > 1) {
        console.error('More than one active sales processes found. Please contact runway. Meantime, using the latest as the active one');
      }

      const arcApprovalProcesses = activeProcesses.filter(salesProcess => salesProcess.processId === '' + 135);
      if ((arcApprovalProcesses !== null && arcApprovalProcesses !== undefined) && (arcApprovalProcesses.length > 0)) {
        this.arcApprovalProcessData = arcApprovalProcesses[arcApprovalProcesses.length - 1];
        //this.changeToInProgress();
      }

      const salesProcesses = activeProcesses.filter(salesProcess => salesProcess.processId === '' + 128);
      if ((salesProcesses !== null && salesProcesses !== undefined) && (salesProcesses.length > 0)) {
        this.activeSalesProcess = salesProcesses[salesProcesses.length - 1];
      } else {
        this.activeSalesProcess = activeProcesses[0];
      }

    },

    createPackageDetailMarker: function (hnlSummary, coord) {
      api.listSalesProcessByPackageCpId(hnlSummary.cpidstring).then(processes => {
        const salesProcesses = processes.data;
        if ((salesProcesses !== null && salesProcesses !== undefined) && salesProcesses.length > 0) {
          this.processActiveSalesProcess(salesProcesses);
          this.generatePopup(hnlSummary, coord);
        } else {
          this.generatePopup(hnlSummary, coord);
        }
      })
    },

    generatePopup(hnlSummary, coord) {
      this.showDetail = true;
      if (this.lotPanelMarker) {
        this.lotPanelMarker.remove();
      }
      this.lotmarkers.forEach(m => {
        m.remove();
      })
      const markerBound = new mapboxgl.LngLatBounds();
      coord.forEach((cord) => {
        markerBound.extend(new mapboxgl.LngLat(cord[0], cord[1]));
      });
      let el;
      if (hnlSummary.currentstatusname === "Spec" || hnlSummary.currentstatusname === "Available" || hnlSummary.currentstatusname === 'Contingent Spec') {
        el = this.getPackageTile(hnlSummary)
      } else {
        el = this.getPackageDetailTile(hnlSummary);
      }

      if (this.activeSalesProcess.salesProcessVpbs && this.activeSalesProcess.salesProcessVpbs.length > 0) {
        const columnsDiv = document.createElement('div');
        columnsDiv.classList.add('columns');
        columnsDiv.classList.add('is-flex');
        columnsDiv.style.flexDirection = 'column';
        columnsDiv.style.margin = '0px';
        this.activeSalesProcess.salesProcessVpbs.forEach(item => {
          if (item.active === true) {
            const columnEl = document.createElement('div');
            columnEl.classList.add('column');
            columnEl.classList.add('pb-1');
            columnEl.classList.add('pt-1');
            columnEl.innerHTML = this.generateVpb(item);
            columnsDiv.appendChild(columnEl);
          }
        });
        el.appendChild(columnsDiv)
      }

      if (hnlSummary.currentstatusname === "Spec" || hnlSummary.currentstatusname === "Available") {
        const aDetailEl = document.createElement('a');
        aDetailEl.classList.add('explore');
        aDetailEl.classList.add('mb-3');
        aDetailEl.classList.add('mt-3');
        aDetailEl.innerHTML = 'EXPLORE THIS HOME';

        el.lastElementChild.appendChild(aDetailEl);
        aDetailEl.addEventListener('click', () => {
          this.$router.push({
            path: '/community/package/' + hnlSummary.cpidstring
          })
          setTimeout(() => {
            if (this.lotPanelMarker) {
              this.lotPanelMarker.remove();
            }
          })
        })
      }

      const aEl = document.createElement('a');
      aEl.classList.add('modal-close');
      aEl.addEventListener('click', (e) => {
        e.stopPropagation();
        this.showDetail = false;
        this.reset();
      }, true)

      el.appendChild(aEl);

      this.map.flyTo({
        center: markerBound.getCenter(),
        zoom: 18,
        essential: true
      });

      this.lotPanelMarker = new mapboxgl.Marker({
        element: el,
        anchor: 'bottom',
        offset: [0, -40]
      });
      this.lotPanelMarker.setLngLat(markerBound.getCenter());
      this.lotPanelMarker.addTo(this.map);
    },

    generateVpb(item) {
      let vpb = '';
      if (item.vpbCategoryName) {
        vpb = vpb + `${item.vpbCategoryName} - `
      }
      if (item.vpbSubCategoryName) {
        vpb = vpb + `${item.vpbSubCategoryName} - `
      }
      if (item.salesProcessVpbDescription) {
        vpb = vpb + `${item.salesProcessVpbDescription}`
      }
      return vpb;
    },

    reset: function () {
      this.resetTileView();
    },

    resetTileView: function () {
      if (this.lotPanelMarker) {
        this.lotPanelMarker.remove();
      }
    },

    createLotMarker: function (e) {
      const lotFeatures = JSON.parse(e.features.properties.lotproperties);
      let el;
      if (this.lotPanelMarker) {
        this.lotPanelMarker.remove();
      }
      if (lotFeatures.currentstatusname === 'Model') {
        if (this.modelHomes && this.modelHomes.length) {
          el = this.createModeHomePopup(lotFeatures)
        }
      } else {
        el = this.createLotPopup(lotFeatures)
      }

      this.map.flyTo({
        center: [e.point.lng, e.point.lat],
        zoom: 18,
        essential: true
      });

      if (el) {
        this.lotPanelMarker = new mapboxgl.Marker({
          element: el,
          anchor: 'bottom',
          offset: [0, -40]
        }).setLngLat([e.point.lng, e.point.lat]);
        this.lotPanelMarker.addTo(this.map)
      }
    },

    createModeHomePopup: function (lotFeatures) {
      const hnlSummary = this.modelHomes.find(item => item.lotproductcpid === lotFeatures.lotcpid);
      if (!hnlSummary) return null;

      const el = document.createElement('div');
      el.classList.add('home-select-popup', 'card');
      el.innerHTML =
        `<div class="facade-image">
          <figure class="image is-3by2">
            <img src="${hnlSummary.imagepath}" alt="">
          </figure>
        </div>`;

      const infoEl = document.createElement('div');
      infoEl.classList.add('card-info');
      infoEl.innerHTML =
        `<div class="columns is-mobile is-gapless">
            <div class="column design">
              <p class="design">${hnlSummary.designproductname}</p>
              <p class="d">${hnlSummary.buildername}</p>
              <p class="mt-2 pr-1">${hnlSummary.productaddress}</p>
            </div>
            <div class="column is-narrow">
              <div class="amenities">
                <div class="amenity">
                  <img src="${require('@/assets/icons/bed.svg')}" alt="">
                  <span>${hnlSummary.noofbedrooms}</span>
                </div>
                <div class="amenity">
                  <img src="${require('@/assets/icons/bath.svg')}" alt="">
                  <span>${hnlSummary.noofbathrooms}</span>
                </div>
                <div class="amenity">
                  <img src="${require('@/assets/icons/car.svg')}" alt="">
                  <span>${hnlSummary.noofcarparks}</span>
                </div>
              </div>
              <div class="price" id="runway-price">
              <p class="p">$${showPackagePrice(hnlSummary)}</p>
            </div>
            <div id="call-builder-for-price">
              <p class="is-size-6">${showPackagePrice(hnlSummary)}</p>
            </div>
            </div>
          </div>`

      el.appendChild(infoEl);
      return el;
    },

    createLotPopup: function (lotFeatures) {
      let sqft = 'n/a'
      if (lotFeatures.productsize && lotFeatures.productsize != 0) {
        sqft = lotFeatures.productsize + ' sqft';
      }
      const el = document.createElement('div');
      el.classList.add('lot-select-popup');
      const htmlcontent = `
      <div class="pop-title">Homesite ${lotFeatures.productname}</div>
        <div class="pop-dim">
          <div>
            <p>Area</p>
            <p>${sqft}</p>
          </div>
          <div>
            <p>Lot Size</p>
            <p>${lotFeatures.lotgroup}</p>
          </div>
          <div>
            <p>Builder</p>
            <p>${lotFeatures.allocatedBuilderName}</p>
          </div>
        </div>
      `;
      el.innerHTML = htmlcontent;
      const aEl = document.createElement('a');
      const imgEl = document.createElement('img');
      imgEl.src = require('@/assets/icons/select_home.svg');
      el.appendChild(aEl);
      aEl.appendChild(imgEl);

      aEl.addEventListener('click', () => {
        this.activeLot = lotFeatures;
      })
      return el;
    },

    filterMapLots: function (lotsummary) {
      if (this.lotPanelMarker) {
        this.lotPanelMarker.remove();
      }
      this.viewBasedFilterLot.features = [];
      this.filteredlotGeoJson.features.forEach((feature) => {
        feature.properties.isActive = false;
        const lot = lotsummary.find((item) => {
          return item.productname === feature.properties.lotName && item.lotcpid === feature.properties.lotCpId;
        });
        if (lot) {
          feature.properties.color = this.assignColor(lot.currentstatusname);
          if (feature.properties.status === 'available') {
            feature.properties.interact = true;
            this.viewBasedFilterLot.features.push(feature);
          } else {
            feature.properties.interact = false;
          }
        } else {
          feature.properties.color = '#333333';
          feature.properties.interact = false;
        }
      });

      this.map.getSource('lots').setData(this.filteredlotGeoJson);

      const bounds = new mapboxgl.LngLatBounds();
      this.viewBasedFilterLot.features.forEach((feature) => {
        feature.geometry.coordinates[0].forEach((cord) => {
          bounds.extend(new mapboxgl.LngLat(cord[0], cord[1]));
        });
      });
      if (this.viewBasedFilterLot.features.length > 0) {
        this.map.fitBounds(bounds, {
          padding: 20,
          maxZoom: 18,
        }, );
      } else {
        this.map.fitBounds(this.masterBound, {
          padding: 20,
        });
      }
    },

    flyTo: function (lotId, mark) {
      this.viewBasedFilterLot.features = [];
      const lotGeo = this.filteredlotGeoJson.features.find(item => {
        return lotId === item.properties.lotCpId;
      });

      if (lotGeo) {
        const bounds = new mapboxgl.LngLatBounds();
        lotGeo.geometry.coordinates[0].forEach((cord) => {
          bounds.extend(new mapboxgl.LngLat(cord[0], cord[1]));
        });
        // const point = item.geometry.coordinates[0][0];
        const m = {
          point: bounds.getCenter(),
          features: {
            properties: {
              lotproperties: JSON.stringify(lotGeo.properties.lotproperties)
            }
          }
        }
        this.createLotMarker(m);
        // item.properties.isActive = true;
        this.map.fitBounds(bounds, {
          maxZoom: 19,
        });
      }
    },

    showPackagePrice: function (hnlSummary) {
      const specStatusId = '7033741562122316063';
      const modelStatusId = '4200111562122316041';
      let priceString = '';
      if(hnlSummary.currentstatusid === specStatusId) {
        priceString = hnlSummary.productprice.toLocaleString(undefined, {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        })
      } else {
        priceString = hnlSummary.planPrice.toLocaleString(undefined, {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        })
      }
      if(window.location.href.includes('favorite')) {
        if(hnlSummary.planPrice <= 0 || !hnlSummary.planPrice || !hnlSummary.productprice || hnlSummary.productprice <= 0) {
          setTimeout(() => {
            const priceEl = document.getElementById('runway-price');
            const callBuilderEl = document.getElementById('call-builder-for-price');
            priceEl.style.display = 'none';
            callBuilderEl.style.display = 'block';
          }, 50);
          priceString = "Call Builder for Pricing"
        }
      }
      return priceString
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/journey/Map.js